<template>
  <v-dialog :value="value" persistent width="800">
      <v-card color="fill">
        <template v-if="isShuttling">
          <v-container class="pa-6">
            <v-progress-linear indeterminate height="25" rounded>
            Preparing to Shuttle...
            </v-progress-linear>
          </v-container>
          
        </template>
        <template v-else>
        <v-card-title :class="title">Shuttle Ad</v-card-title>
        <v-container class="ma-0 pa-0">
          <v-data-table
            height="500"
            dense
            :items.sync="adGroups"
            :headers="headers"
            :search="search"
            :loading="loading"
            :items-per-page="pageSize"
            hide-default-footer
            fixed-header
            item-key="party_name"
            item-value="party_id"
            show-select
            v-model='selected'
          >

            <template #top>
              <v-toolbar>
                <v-row>
                  <v-col cols="6">
                    <v-text-field label="Filter Parties" prepend-inner-icon="mdi-filter-variant" v-model="search" dense outlined class='mt-4'/>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col v-if="$auth.tenant === 'alliance-retail-group'" cols="3" class="mb-2" align-self="center">
                    <v-row>
                      <strong>Total Parties:</strong> {{ adGroups.length }}
                    </v-row>
                    <v-row v-if="selected.length > 0">
                      <strong>Selected Parties:</strong> {{ selected.length }}
                    </v-row>
                  </v-col>
                </v-row>                 
              </v-toolbar>
            </template>
          </v-data-table>
        </v-container>

            <v-toolbar color="fill" flat>
              <span v-if='!permit' class='primary--text'>Cannot Shuttle an Ad with no Promo Items</span>
                <v-spacer/>
                <v-btn :class="body" text @click.stop="$emit('update:value', false)">Cancel</v-btn>

                <v-btn 
                  :class="body" 
                  class="ma-2"
                  :loading="isShuttling || loadingAds"
                  :disabled="!permit || loadingAds"
                  color="success"
                  @click.stop="bulkShuttle"
                  >Shuttle
                </v-btn>
            </v-toolbar>
        </template>
        <ExistingAdShuttleModal
          v-if="warningsModal" 
          v-model="warningsModal" 
          :selectedAd="selectedAd"
          :existingAds="existingAds"
          :adGroups="adGroups"
          @cancel="closeWarningsModal" 
          @confirmAction="confirmAction">
        </ExistingAdShuttleModal>
    </v-card>
  </v-dialog>
</template>
<script>
import { displayHelpers } from '@/mixins/display-helpers'
import { utils } from '@/mixins/utils'
import { displayAlert } from '@/mixins/alert'
import Bottleneck from 'bottleneck'
const ExistingAdShuttleModal = () => import('@/components/ads/ExistingAdShuttleModal.vue')
export default {
  name: 'AdShuttle',
  props: {
    value: Boolean,
    selectedAd: Object, 
    defaultParty: Object 
  },
  components: { ExistingAdShuttleModal },
  mixins: [displayHelpers, utils, displayAlert],
  data () {
    return {
      search: '',
      selected:[],
      selections:[],
      adGroups:[],
      ids:[],
      items: [],
      loading: false,
      loadingAds: false,
      isShuttling: false,
      upstream: [],
      downstream: [],
      upstreamRes:[],
      downstreamRes:[],
      downstreamParams:{},
      priorShuttles:[],
      permit: false,
      partyInfo: {},
      pageSize: 100,
      argAdGroupCodeExclusions: ['BPC', 'HHS', 'QPC', 'BCW', 'CPG', 'CMA', 'CPC'],
      existingAds: [],
      warningsModal: false
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Ad Groups', sortable: true, filterable: true, value: 'party_name' },
      ]
    },
    storedAdGroups () {
      return this.$store.getters.adGroups
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value){
        this.getAdGroupsForShuttle()
        this.countItems()
        } 
      }
    },
  },
  methods: {
    async getAdGroupsForShuttle() {
      this.loading = true
      try {
        const { data } = await this.$Ads.getShuttleAdGroups(this.selectedAd.id, this.defaultParty.id)
        if (data?.length > 0) {
          this.adGroups = this.filterAdGroups(data)
        }
      } catch (err) {
        console.error(err)
        this.$store.dispatch('setSnackbar', { status: 'error', text: `Failed to Get Ad Group List due to ${err?.response?.data?.message || err.message}` })
      } finally {
        this.loading = false
      }
    },
    async shuttleAd (id) {
      const body = {party_id:id, note:''}
      const ad_id = this.selectedAd.id
      if (this.permit === true) {
        await this.$Ads.shuttle(ad_id, body)
      } else {
        this.$store.dispatch('setSnackbar', { status: 'error', text: `Cannot Shuttle An Ad With No Promo Items` })
      }
    },
    async getExistingAds() {
      this.existingAds = []
      try {
        const start_date = Date.parse(this.selectedAd.ad_start_date)
        const promises = this.selected.map(party => {
          return this.$Ads.search(party.party_id, { start_date })
        })
        const { fulfilled, rejected } = await this.getAllSettled(promises, true)
        if (rejected?.length > 0) throw rejected
        if (fulfilled?.length > 0) {
          this.existingAds = fulfilled.flatMap(result => result.data)
        }
      } catch (err) {
        this.handleError(err)
      }
    },
    async bulkShuttle(showWarning = true, deleteExisting = false) {
      if (this.$auth.tenant === 'alliance-retail-group') {
        this.loadingAds = true
        await this.getExistingAds()
        if (this.existingAds?.length > 0 && showWarning) {
          this.loadingAds = false
          return this.warningsModal = true
        }
      }
      this.isShuttling = true
      try {
        if (deleteExisting && this.existingAds?.length > 0) {
          await this.deleteExistingAds()
        }
        const limiter = new Bottleneck({
          reservoir: 25,
          reservoirRefreshAmount: 25,
          reservoirRefreshInterval: 5 * 1000,
          maxConcurrent: 25,
          minTime: 0
        })
        const throttledShuttle = limiter.wrap(this.shuttleAd)

        const allThePromises = this.selected.map(party => {
          return throttledShuttle(party.party_id)
        })

        await Promise.all(allThePromises)
        this.$emit('update:value', false)
        this.$store.dispatch('setSnackbar', { status: 'success', text: `Shuttle successfully submitted` })
      } catch(err) {
        console.error(err)
        this.$store.dispatch('setSnackbar', { status: 'error', text: `Shuttle failed due to ${err?.response?.data?.message || err.message}` })
      } finally {
        this.isShuttling = false
      }
    },
    async deleteExistingAds() {
      try {
        const promises = this.existingAds.map(ad => {
          return this.$Ads.deleteAd(ad.id)
        })
        const { rejected } = await this.getAllSettled(promises, true)
        if (rejected?.length > 0) throw rejected
      } catch (err) {
        this.handleError(err)
      }
    },
    async countItems(){
      await this.$Ads.countItems(this.selectedAd.id).then(res=>{
        if(res.data.number_of_items != 0){
          this.permit = true
        }
        else this.permit = false
      }).catch(err=>{
        this.$store.dispatch('setSnackbar', { status: 'error', text: `Failed to check shuttle status due to ${err?.response?.data?.message || err.message}` })
      })
    },
    filterAdGroups(adGroups) {
      if (this.$auth.tenant === 'alliance-retail-group') {
        const adGroupsWithCodes = adGroups.map(ag => { return {...ag, AD_GROUP_CODE: this.storedAdGroups.find(g => g.party_id === ag.party_id).attributes.AD_GROUP_CODE }})
        return adGroupsWithCodes.filter(ag => !this.argAdGroupCodeExclusions.includes(ag.AD_GROUP_CODE))
      } else {
        return adGroups
      }
    },
    closeWarningsModal() {
      this.warningsModal = false
    },
    confirmAction(deleteExisting) {
      this.warningsModal = false
      this.bulkShuttle(false, deleteExisting)
    }
  }
}
</script>
